import React from "react";
import { useTranslation } from "react-i18next";
import { LANGUAGES, setLanguage } from "@/i18n";
import { Globe } from "lucide-react";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export default function LanguageSwitcher({ variant = "dark" }) {
  const { i18n, t } = useTranslation();
  const current = LANGUAGES.find((l) => l.code === (i18n.resolvedLanguage || i18n.language)?.split("-")[0]) || LANGUAGES[0];

  const change = (code) => setLanguage(code);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="language-switcher"
          aria-label={t("lang.choose")}
          className={`inline-flex items-center gap-1.5 h-9 max-xl:min-h-11 px-2.5 rounded-md border text-sm font-medium transition-colors duration-150 ${
            variant === "dark"
              ? "border-white/15 text-slate-200 hover:bg-white/10"
              : "border-slate-300 text-slate-700 hover:bg-slate-100"
          }`}>
          <Globe size={16} />
          <span className="hidden sm:max-xl:inline 2xl:inline">{current.native}</span>
          <span className="sm:max-xl:hidden 2xl:hidden uppercase">{current.code}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[160px]">
        {LANGUAGES.map((l) => (
          <DropdownMenuItem
            key={l.code}
            data-testid={`lang-option-${l.code}`}
            onClick={() => change(l.code)}
            className={`cursor-pointer ${current.code === l.code ? "text-primary font-semibold" : ""}`}>
            <span className="flex-1">{l.native}</span>
            <span className="text-xs text-slate-400 ml-2">{l.label}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
